// extracted by mini-css-extract-plugin
export default {"wrapper":"BKlOBi","container":"y6Ax1B","slide":"bQlWow","videoContainer":"bg2O3w","slideTextContainer":"avb11B","fadeIn":"cIMZuO","buttonsContainer":"Ici_XI","gallery":"m8cLEb"};